module.exports = __webpack_public_path__ + "img/CM-MR-CA-Mazda-Playful.311fb846.jpeg";